import { useTranslation } from 'next-i18next';
import { useFormContext } from 'react-hook-form';
import { themeColors } from 'utils/tailwind/tailwindHelpers';

import { IPropertySettings } from '@/modules/settings/property/types';
import { InputField, SelectField, Typography } from '@/shared/components/atoms';
import { allPropertyFields } from '@/shared/constant/general';

const EditFieldBasicInfo: React.FC<{ isFarmField: boolean }> = ({
  isFarmField,
}) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors, isSubmitting },
    getValues,
  } = useFormContext<IPropertySettings.ICreateEditFieldFormValues>();

  return (
    <div className='grid grid-cols-2 gap-24'>
      <InputField
        borderColor='border-outline-variant'
        width='w-full'
        py='!py-16'
        label={t('name')}
        placeholder={t('Field Name')}
        error={!!errors.name}
        errorMessage={errors.name?.message}
        className='!rounded-xl bg-background-transparent'
        disabled={isSubmitting}
        {...register('name')}
      />
      <SelectField
        id='type'
        isDisabled
        getLabel={(obj: { label: string; value: string }) => obj.label}
        getValue={(obj: { label: string; value: string }) => obj.value}
        className='!rounded-xl bg-background-transparent'
        borderColor={themeColors().outline.variant}
        label={t('Field Type')}
        placeholder={t('Field Type')}
        isMulti={false}
        list={allPropertyFields.map((field) => ({
          label: field,
          value: field,
        }))}
        py='10px'
        px='0.5rem'
        borderRadius='1rem'
        width='w-full'
      />
      {isFarmField && (
        <InputField
          borderColor='border-outline-variant'
          width='w-full'
          py='!py-16'
          label={t('area')}
          placeholder={t('area')}
          error={!!errors.area}
          errorMessage={errors.area?.message}
          className='!rounded-xl bg-background-transparent'
          disabled={isSubmitting}
          {...register('area')}
          type='number'
          step='0.001'
          suffix={<Typography>{t(getValues('areaUnit'))}</Typography>}
        />
      )}
    </div>
  );
};

export default EditFieldBasicInfo;
